// extracted by mini-css-extract-plugin
module.exports = {"benefitItemStyle":"style_benefitItemStyle__sqYV4"};